import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import InputField from 'components/Credit24/Core/Controls/InputField';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';
import InputToggleGroup from 'components/Credit24/Core/Controls/InputToggleGroup';
import InputToggleField from 'components/Credit24/Core/Controls/InputToggleField';

const DEFAULT_GRID_CLASS = 'one-third palm-one-whole';

const LoanSection = ({
  name,
  titleId,
  tooltipId,
  subtitleId,
  hasFlag,
  loanTypes,
  paymentFrequencies,
  countField,
  totalRepayField,
  freqFieldName,
}) => (
  <>
    <Field
      title={<FormattedHTMLMessage id={titleId} />}
      {...(tooltipId ? { tooltip: <FormattedHTMLMessage id={tooltipId} /> } : {})}
      {...(subtitleId ? { subtitle: <FormattedHTMLMessage id={subtitleId} /> } : {})}
      name={name}
      component={InputToggleField}
    />
    {hasFlag && (
      <div className="grid">
        {countField && (
          <div className={`grid__item ${countField.gridClass || DEFAULT_GRID_CLASS}`}>
            <Field
              emptyTextKey={countField.emptyTextKey}
              name={countField.name}
              component={InputSelectField}
              options={loanTypes}
              isFullWidth
            />
          </div>
        )}

        {totalRepayField && (
          <div className={`grid__item ${totalRepayField.gridClass || DEFAULT_GRID_CLASS}`}>
            <Field
              title={<FormattedHTMLMessage id={totalRepayField.titleId} />}
              name={totalRepayField.name}
              component={InputField}
              prefix="$"
              useDigitsGrouping
              isFullWidth
              {...(totalRepayField.hintKey
                ? { hintConfig: { titleKey: totalRepayField.hintKey } }
                : {})}
            />
          </div>
        )}

        {freqFieldName && (
          <div className={`grid__item ${freqFieldName.gridClass || DEFAULT_GRID_CLASS}`}>
            <InputToggleGroup
              name={freqFieldName.name}
              list={paymentFrequencies}
            />
          </div>
        )}
      </div>
    )}
  </>
);

LoanSection.propTypes = {
  name: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  tooltipId: PropTypes.string,
  subtitleId: PropTypes.string,
  dependsOn: PropTypes.string,
  hasFlag: PropTypes.bool.isRequired,
  loanTypes: PropTypes.array.isRequired,
  paymentFrequencies: PropTypes.array.isRequired,
  countField: PropTypes.shape({
    name: PropTypes.string.isRequired,
    emptyTextKey: PropTypes.string.isRequired,
    gridClass: PropTypes.string,
  }),
  totalRepayField: PropTypes.shape({
    name: PropTypes.string.isRequired,
    titleId: PropTypes.string.isRequired,
    hintKey: PropTypes.string,
    gridClass: PropTypes.string,
  }),
  freqFieldName: PropTypes.shape({
    name: PropTypes.string.isRequired,
    gridClass: PropTypes.string,
  }),
};

export default LoanSection;
